import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { DailyCardPage } from '../features/daily-card/page'

export const dailyCardRoute = createRoute({
  path: 'daily-card',
  getParentRoute: () => rootRoute,
  component: DailyCardPage,
})
